import React, { useEffect } from 'react'
import logoutQueryString from 'src/utils/logoutQueryString'
import Footer from 'src/components/Footer/Footer'
import Navbar from 'src/components/Navbar/Navbar'
import LaboratoryContent from 'src/components/LaboratoryContent/LaboratoryContent'

const LaboratoryPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    logoutQueryString()
  }, [])

  return (
    <>
      <Navbar />
      <LaboratoryContent />
      <Footer />
    </>
  )
}

export default LaboratoryPage
